/**
 * Transform the errors to string messages
 *
 * @param  {Object} state
 * @return {Object}
 */
const errors = state => {
    return Object.keys(state.error).reduce((result, i) => {
        result[i] = state.error[i].join(', ')
        return result
    }, {})
}

export default {
    errors
}



// WEBPACK FOOTER //
// ./src/state/modules/profile/getters.js